// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fdzt","col":"styles_col__J7VzL"};